export default __webpack_public_path__ + "static/media/Park.53b81db8.svg";